import request from 'components/Utils/Request';
const { REACT_APP_API_URL } = process.env;
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

// Change-password
export const changePasswordRequest = () => ({
  type: CHANGE_PASSWORD_REQUEST
});
export const changePasswordSuccess = payload => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload
});
export const changePasswordFailure = payload => ({
  type: CHANGE_PASSWORD_FAILURE,
  payload
});

// Change-password
export const ChangePasswordAction = payload => {
  return {
    type: 'CHANGEPASSWORD',
    payload
  };
};

  
export const changePasswordDetailErrorAction = payload => {
  return {
    type: 'CHANGEPASSWORDERROR',
    payload
  };
};

export const changePasswordAPI = (payload, successData, errorMsg, header = {}) => {
  return (dispatch) => {
    dispatch(changePasswordRequest());
    return request("POST", `${REACT_APP_API_URL + "/change-password"}`, payload, "", header)
      .then((response) => {
        if (response?.data?.status === 200) {
          successData(response);
          dispatch(changePasswordSuccess(response));
        } else {
          errorMsg(response);
        }

      }).catch((error) => {
        errorMsg(error?.response);
        dispatch(changePasswordFailure("Something Went Wrong"));
        throw error;
      });
  };
};